<template>
  <div class="item">
    <div v-if="isCompare">
      <div class="top">
        <div class="title" :style="{ backgroundColor: getColor() }">
          {{ compareValue() }}
        </div>
      </div>
      <div class="bottom">
        <div class="left">{{ getValue(model?.num1) }}</div>
        <div class="right">{{ getValue(model?.num2) }}</div>
      </div>
    </div>
    <div v-else class="one-box">
      {{ getValue(model?.num1) }}
    </div>
  </div>
</template>
<script>
export default {
  name: "item",
  props: {
    index: {
      type: Number,
      default: 0,
    },
    model: {
      type: Object,
      default: () => {},
    },
    headerTitle: {
      type: String,
      default: "",
    },
    isCompare: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    getItemValue(value) {
      let isTimeValue = false;
      if (
        this.headerTitle.includes("Time") ||
        this.headerTitle.includes("time")
      ) {
        isTimeValue = true;
      }
      let h, min, sec, sum;
      if (isTimeValue) {
        if (value.includes("h")) {
          h = value.split("h")[0];
          const timeStr = value.split("h")[1];
          if (timeStr.includes("m")) {
            min = timeStr.split("m")[0];
            sec = timeStr.split("m")[1];
          }
          sum = h * 3600 + min * 60 + parseFloat(sec);
        } else if (value.includes("m")) {
          min = value.split("m")[0];
          sec = value.split("m")[1];
          sum = min * 60 + parseFloat(sec);
        } else if (value.includes("s")) {
          sum = parseFloat(value);
        } else {
          sum = parseFloat(value);
        }
      } else {
        sum = parseFloat(value);
      }
      return sum;
    },
    getValue(num) {
      if (num) {
        return num;
      }
      return "-";
    },
    getColor() {
      // console.log("this.model = ", this.model);
      if (!this.model?.num1 || !this.model?.num2 || (this.model?.num1 == this.model?.num2)) {
        return "#707070";
      } else {
        if (parseFloat(this.model?.num1) > parseFloat(this.model?.num2)) {
          return "#F18B8B";
        } 
        return "#AEDFA9";
      }
    },
    compareValue() {
      if (this.model?.num1 && this.model?.num2) {
        let valueStr = "";
        if (this.model?.num1 == this.model?.num2) {
          return "/";
        } else {
          const v1 = this.getItemValue(this.model?.num1);
          const v2 = this.getItemValue(this.model?.num2);
          const comValue = 1 - v1 / v2;
          if (v2 == 0) {
            return "/";
          } else {
            if (comValue == 0) {
              valueStr = comValue * 100 + "%";
              return "/";
            } else {
              valueStr = (comValue * 100).toFixed(1) + "%";
            }
          }
          console.log("valueStr = ", valueStr);
          return valueStr;
        }
      }
      return "/";
    },
  },
  computed: {},
  created() {},
};
</script>
<style lang='less' scoped>
.item {
  width: 100%;
  .top {
    height: 25px;
    width: 100%;
    background-color: #aedfa9;

    .title {
      height: 100%;
      width: 100%;
      color: #ffffff;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .bottom {
    height: 50px;
    width: 100%;
    display: flex;
    flex-direction: row;
    color: #565656;

    .left {
      background-color: #ffffff;
      font-size: 14px;
      display: flex;
      align-items: center;
      width: calc(100% / 2);
      padding: 0px 5px 0px 10px;
    }
    .right {
      background-color: #f6f6f6;
      font-size: 14px;
      display: flex;
      width: calc(100% / 2);
      padding: 0px 5px 0px 10px;
      align-items: center;
    }
  }

  .one-box {
    height: 100%;
    width: 100%;
    color: #565656;
    background-color: #ffffff;
    font-size: 14px;
    display: flex;
    align-items: center;
    padding-left: 10px;
  }
}
</style>